import { getSeoPageByPath, normalizePath } from './seoPages';
import { isKnownCrawler } from './statsEntry';

export const isPlansPath = (pathname) => normalizePath(pathname) === '/planes';

export function getPlansEntry(pathname, userAgent = '', prerenderedPath = '') {
  if (!isPlansPath(pathname)) return { page: null, keepStatic: false };
  return {
    page: getSeoPageByPath('/planes'),
    keepStatic: isKnownCrawler(userAgent) && isPlansPath(prerenderedPath)
  };
}